<template>
  <div>
    <div class="form-container" style="padding: 0">
      <el-form inline size="mini" label-width="100px" :model="conditions" disabled>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="产品ID">
              <el-input v-model="conditions.product_id" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="度数">
              <el-input v-model="conditions.degree" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品描述" prop="short_text">
              <el-input v-model="conditions.short_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="盒装瓶数" prop="hzps">
              <el-input v-model="conditions.hzps" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品简介" prop="short">
              <el-input v-model="conditions.short" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="箱装盒数" prop="xzhs">
              <el-input v-model="conditions.xzhs" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-select
                v-model="conditions.chfl"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectDataOptions['A0019']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否有条形码">
              <el-checkbox v-model="conditions.isbar" true-label="X" false-label="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基本单位">
              <el-input v-model="conditions.base_uom_text" value="盒" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="条形码">
              <el-input v-model="conditions.bcode" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="老编码">
              <el-input v-model="conditions.onumb" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="容量">
              <el-input v-model="conditions.capty" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="显示规格">
              <el-input v-model="conditions.norms" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="变更自产品">
              <el-input v-model="conditions.product_id" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品分类">
              <el-select
                v-model="conditions.pcate"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectDataOptions['A0017']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="归档标识">
              <el-checkbox v-model="conditions.zzfld000026" true-label="X" false-label="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="归档日期">
              <el-input v-model="conditions.zzfld000026_date" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="归档备注">
              <el-input v-model="conditions.remark_gd" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="停用标识">
              <el-checkbox v-model="conditions.block" true-label="X" false-label="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="停用日期">
              <el-input v-model="conditions.block_date" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="停用备注">
              <el-input v-model="conditions.remark_blk" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项1">
              <el-select v-model="conditions.reserved1">
                <el-option value="E0006" label="预留项1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项2">
              <el-select v-model="conditions.reserved2">
                <el-option value="E0006" label="预留项2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项6">
              <el-input v-model="conditions.reserved6" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预留项7">
              <el-input v-model="conditions.reserved7" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input v-model="conditions.datum" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建者">
              <el-input v-model="conditions.uname_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="更改日期">
              <el-input v-model="conditions.mdate" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="更改者">
              <el-input v-model="conditions.mname_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="货主编码">
              <el-input v-model="conditions.shipper_text" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container" style="padding: 0">
      <TableCommon
        title="营销单元"
        :custome-config="() => vxeShowCustom('xTableSaleCenter')"
      >
        <vxe-grid
          ref="xTableSaleCenter"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="saleCenterGridOptions.columns"
          :data="saleCenterGridOptions.data"
        />
      </TableCommon>

      <TableCommon
        title="变更自产品"
        :custome-config="() => vxeShowCustom('xTable2')"
      >

        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridDataOptions.columns"
          :data="gridDataOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  props: {
    prod: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      conditions: {
        product_id: '', // 产品id
        short: '', // 产品简介
        norms: '', // 显示规格
        onumb: '', // 老编码
        reserved1: '', // 预留1
        reserved2: '',
        reserved6: '',
        reserved7: '',
        xzhs: '', // 箱装盒数
        bcode: '', // 条形码
        capty: '', // 容量
        chfl: '', // 存货分类
        degree: '', // 度数
        hzps: '', // 盒装瓶数
        isbar: '', // 是否有条形码
        pcate: '', // 产品分类
        short_text: '', // 产品描述
        base_uom: '', // 基本单位
        base_uom_text: '',
        zzfld000026: '', // 归档标识
        zzfld000026_date: '',
        uname_text: '',
        mname_text: '',
        datum: '', // 创建日期
        uname: '', // 创建者
        mdate: '', // 更改日期
        mname: '', // 更改者
        block: '',
        block_date: '',
        remark_blk: '',
        shipper_text: ''
      },
      selectDataOptions: {},
      saleCenterGridOptions: {
        columns: [
          {
            field: 'zzfld00001h_dec',
            title: '营销单元'
          }
        ],
        data: []
      },
      gridDataOptions: {
        data: [],
        columns: [
          { type: 'seq', title: '序号', field: 'seq', width: 50 },
          { field: 'product_id_f', title: '初始产品' },
          { field: 'product_id_t', title: '变更产品' },
          { field: 'mdate', title: '变更日期' }
        ]
      }
    }
  },
  created() {
    this.findWlyOrg()
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0017')
    for (const key in this.conditions) {
      this.conditions[key] = this.prod[key] || ''
    }
    this.saleCenterGridOptions.data = this.prod.yxdy
    this.gridDataOptions.data = this.prod.history
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 获取组织机构
    async findWlyOrg() {
      const { DATA } = await apiGetOrgOrBase()
      this.$set(this.selectDataOptions, 'saleCenterCodeOptions', DATA)
    },
    submitForm() {
      return {
        base: this.conditions,
        saleCenter: this.saleCenterGridOptions.data
      }
    },
    insertSaleCenter() {
      const data = {
        mandt: '',
        product_guid: this.prod.product_guid,
        product_id: this.prod.product_id,
        zzfld00001h: ''
      }
      this.saleCenterGridOptions.data.unshift(data)
    },
    removeSaleCenter() {
      const checkedList = this.$refs.xTableSaleCenter.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.saleCenterGridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.saleCenterGridOptions.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product-manage/components/BaseInfoCheck.vue